import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, InputNumber } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class GradesTamanhoForm extends Component {
  state = {
    registro: {
      gtam_idf: '',
      gtam_ordem: 0,
      gtam_descricao: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        this.refs.gtam_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onInputChangeOrdem = event => {
    const value = event;
    const id = 'gtam_ordem';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  }

  onOK = () => {
    if ((!this.state.registro.gtam_descricao) || (this.state.registro.gtam_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }

    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { gtam_idf, gtam_descricao, gtam_ordem } = this.state.registro;

    // console.log('GradesTamanhoForm: ', this.state)

    return (
      <Modal
        title={gtam_idf ? "Edição de Tamanho de Grade" : "Cadastro de Tamanho de Grade"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"30%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={18} className="camposEspacoDireita">
              <span>Descrição</span>
              <InputForm
                id="gtam_descricao"
                ref="gtam_descricao"
                maxLength={15}
                onChange={this.onChange}
                value={gtam_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: 2 }}>
              <span>Ordem</span>
              <InputNumber
                ref="Input"
                id={gtam_ordem}
                value={gtam_ordem}
                onChange={this.onInputChangeOrdem}
                min={0}
                max={999}
                maxLength={3}
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GradesTamanhoForm.js